import * as yup from 'yup';
import { REGEX_PATTERNS } from '@constants';

const validationSchema = yup.object({
  fullName: yup.string().required('Required'),
  role: yup.string().required('Required'),
  phoneNumberMain: yup
    .string()
    .required('Required')
    .matches(REGEX_PATTERNS.Phone, {
      message: 'Invalid phone number',
    }),
  phoneNumberSecondary: yup
    .string()
    .nullable()
    .notRequired()
    .test('is-valid-phone', 'Invalid phone number', (value) => {
      if (!value) return true; // allow empty, null, undefined
      return REGEX_PATTERNS.Phone.test(value);
    }),
  email: yup.string().required('Required').matches(REGEX_PATTERNS.Email, {
    message: 'Invalid email',
  }),
});

export default validationSchema;
